import React, { useState, useEffect, useRef, useCallback, useImperativeHandle, useContext, useMemo } from 'react';
import { api, apis, inWindow, } from 'api';
import classnames from 'classnames';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import KeyCode from 'rc-util/lib/KeyCode';
import { Dropdown, Menu, message } from 'antd';
import Select from '../RcSelect/contact-select';
import ContactTag from './contact-tag';
import { buildContactItem, buildContactModel, getSearchAllContactInWriteMail, getValidEmail, transMailContactModel2ContactItem, } from '@web-common/utils/contact_util';
import { getContactItemKey, getCustomerContactByCustomerIds, transCustomerSearchData } from '@web-common/components/util/contact';
import { showDialog } from '@web-common/utils/utils';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import './selector.scss';
import { ContactActions, TempContactActions, useActions, useAppSelector, MailTemplateActions, MailActions } from '@web-common/state/createStore';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import styles from './selector.module.scss';
import { buildOptionLabel, buildTeamOptionLabel, extractEmailsFromText, getSelectedEmailsByPoints } from './helper';
import { transContactSearch2ContactItem, transOrgSearch2OrgItem, transContactModel2ContactItem } from '@web-common/components/util/contact';
import { doGetMailContactModelByContactItem } from '@web-common/state/selector/contact';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { paste, isSupportPaste } from '@web-common/components/UI/ContextMenu/util';
import { getIn18Text } from 'api';
import { SelectorProvider } from './SelectorContext';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import ContactDetail from '@web-contact/component/Detail/detail';
const tokenSeparators = [',', ';', '、', '，', '；', '\n'];
const LIST_ITEM_HEIGHT = 32;
const LIST_HEIGHT = LIST_ITEM_HEIGHT * 10;
const RECEIVER_LIMIT = 500;
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const performanceApi = api.requireLogicalApi(apis.performanceImpl);
const mapTrack = new Map([
    ['bcc', 'pcMail_inputBCC_writeMailPage'],
    ['cc', 'pcMail_inputCC_writeMailPage'],
    ['to', 'pcMail_inputAddressee_writeMailPage'],
]);
function elementToggle(el, visible) {
    el.style.display = visible ? 'block' : 'none';
}
const Selector = (props, ref) => {
    const { multiLine = true, type = '', sendMailConflictConfig, autoFocus = false, items = [], keyword, setKeyword, tabIndex, onKeyDown, selectDisabled } = props;
    const { isMailTemplate } = useContext(WriteContext);
    const [focus, setFocus] = useState(false);
    const [inputOrder, setInputOrder] = useState(0);
    const selectedItems = useMemo(() => {
        const selectedItemsMap = new Map();
        items === null || items === void 0 ? void 0 : items.forEach(item => {
            const contactItem = transMailContactModel2ContactItem(item);
            const contactKey = getContactItemKey(contactItem);
            selectedItemsMap.set(contactKey, contactItem);
        });
        return selectedItemsMap;
    }, [items]);
    const [searchContactList, setSearchContactList] = useState();
    const [blurStyle, setBlurStyle] = useState({});
    const maskRef = useRef(null);
    const onContactActions = isMailTemplate ? TempContactActions : ContactActions;
    const { doSelectTags, doAddItemToSelector, doFocusSelector } = useActions(onContactActions);
    const onActions = isMailTemplate ? MailTemplateActions : MailActions;
    const { doModifyReceiver } = useActions(onActions);
    const refSelect = useRef(null);
    const refAdding = useRef({});
    const refSelectWrapper = useRef(null);
    const keywordRef = useRef('');
    const [options, setOptions] = useState([]);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const selectedEmails = useAppSelector(state => (isMailTemplate ? state.tempContactReducer.selectedTags.emails : state.contactReducer.selectedTags.emails));
    const selector = useAppSelector(state => (isMailTemplate ? state.tempContactReducer.selector : state.contactReducer.selector));
    const [contactPos, setContactPos] = useState({
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    });
    const [lastItemPos, setLastItemPos] = useState([0, 0]);
    const [contactCardInfo, setContactCardInfo] = useState();
    const [contactCardVisible, setContactCardVisible] = useState(false);
    const clickShowContactCard = useCallback((contactPos, contactInfo) => {
        setContactPos(contactPos);
        setContactCardVisible(true);
        setContactCardInfo(contactInfo);
    }, []);
    useEffect(() => {
        console.log('contactCardVisible', contactCardVisible);
    }, [contactCardVisible]);
    if (inWindow()) {
        if (!window.location.pathname.includes('writeMail') && !window.location.hash.startsWith('#mailbox') && contactCardVisible) {
            setContactCardVisible(false);
        }
    }
    useEffect(() => {
        setContactCardVisible(false);
    }, [currentTabId, items.length]);
    const selectItem = useCallback(() => {
        setKeyword('');
    }, []);
    useEffect(() => {
        if (!searchContactList)
            return;
        const { data: lxData, edm: edmData, recent: recentList = [] } = searchContactList;
        let frequentContacts = [];
        let personalContacts = [];
        let enterpriseContacts = [];
        let otherContacts = [];
        let teams = [];
        let personalOrgs = [];
        lxData === null || lxData === void 0 ? void 0 : lxData.forEach(normalData => {
            const { frequentContactList, contactList: allContactList, teamList, personalOrgList } = normalData;
            (frequentContactList || []).forEach(item => {
                let contactItem = transContactSearch2ContactItem(item);
                frequentContacts.push(contactItem);
            });
            (allContactList || []).forEach(item => {
                let contactItem = transContactSearch2ContactItem(item);
                const { type } = contactItem;
                if (type === 'enterprise') {
                    enterpriseContacts.push(contactItem);
                }
                else if (type === 'personal') {
                    personalContacts.push(contactItem);
                }
                else {
                    otherContacts.push(contactItem);
                }
            });
            teams = [...teams, ...(teamList || [])];
            personalOrgs.push(...personalOrgList);
        });
        let myCustomerContacts = [];
        let myClueContacts = [];
        let myCustomerOrgs = [];
        let myClueOrgs = [];
        if (edmData) {
            const orderEdmData = transCustomerSearchData(edmData);
            myCustomerContacts = orderEdmData['myCustomerContact'];
            myCustomerOrgs = orderEdmData['myCustomer'];
        }
        const allContactMap = new Map();
        const duplicateRemContacts = [
            ...recentList,
            ...frequentContacts,
            ...enterpriseContacts,
            ...myCustomerContacts,
            ...myClueContacts,
            ...personalContacts,
            ...otherContacts,
        ].reduce((total, cur) => {
            const { email: emailAddr, id } = cur;
            const currentEmailContact = allContactMap.get(emailAddr);
            if (!currentEmailContact) {
                allContactMap.set(emailAddr, cur);
                return [...total, cur];
            }
            if (currentEmailContact.id === id) {
                return [...total];
            }
            return [...total, cur];
        }, []);
        allContactMap.clear();
        const newOptions = [
            ...duplicateRemContacts.map(item => buildOptionLabel(item, keyword, true)),
            ...personalOrgs.map(item => buildTeamOptionLabel(transOrgSearch2OrgItem(item), keyword)),
            ...teams.map(item => buildTeamOptionLabel(transOrgSearch2OrgItem(item), keyword)),
            ...myCustomerOrgs.map(item => buildTeamOptionLabel(item, keyword)),
            ...myClueOrgs.map(item => buildTeamOptionLabel(item, keyword)),
        ];
        setOptions(newOptions);
    }, [searchContactList]);
    const modifyReceiver = useCallback(async (params) => {
        const { receiver: list, receiverType, operation } = params;
        const receiver = await doGetMailContactModelByContactItem(list, receiverType, curAccount === null || curAccount === void 0 ? void 0 : curAccount.id);
        doModifyReceiver({
            receiver,
            receiverType,
            operation,
        });
    }, [curAccount === null || curAccount === void 0 ? void 0 : curAccount.id]);
    const debouncedSearch = useCallback(debounce((value) => {
        keywordRef.current = value;
        const showDisable = false;
        performanceApi.time({
            statKey: 'write_mail_search_contact',
            statSubKey: value,
        });
        const curAccountId = curAccount === null || curAccount === void 0 ? void 0 : curAccount.mailEmail;
        getSearchAllContactInWriteMail({ query: value, showDisable, curAccountId, flattenMuliptleEmails: true }, data => {
            if (keywordRef.current !== value) {
                return;
            }
            performanceApi.timeEnd({
                statKey: 'write_mail_search_contact',
                statSubKey: value,
            });
            data && setSearchContactList(data);
            console.warn('[optimize]writeMail-searchContactAllSpan:' + value, data);
        });
    }, 200), [curAccount]);
    const tagRender = useCallback((props) => {
        return (React.createElement(ContactTag, Object.assign({}, props, { type: type, setLastItemPos: setLastItemPos, refSelect: refSelect, setInputOrder: setInputOrder, sendMailConflictConfig: sendMailConflictConfig, clickShowContactCard: clickShowContactCard, setContactCardVisible: setContactCardVisible })));
    }, [type, focus, clickShowContactCard, setContactCardVisible, sendMailConflictConfig]);
    const dropListener = useCallback((e) => {
        const fromType = e.dataTransfer.getData('type');
        if (fromType === type) {
            return;
        }
        const data = JSON.parse(e.dataTransfer.getData('label'));
        const receiver = data.map((item) => {
            item.mailMemberType = type;
            return item;
        });
        modifyReceiver({
            receiver,
            receiverType: type,
            operation: 'paste',
        });
        modifyReceiver({
            receiver,
            receiverType: fromType,
            operation: 'delete',
        });
        const emails = (data === null || data === void 0 ? void 0 : data.map(d => d.email)) || [];
        doSelectTags({ emails, type });
        const parent = document.querySelector('#drag-active-tags');
        if (parent) {
            parent.innerHTML = '';
        }
    }, [onContactActions]);
    const dragoverListener = (e) => {
        e.preventDefault();
    };
    const writeMailElementInitScrollInfo = useRef({ left: 0, top: 0 });
    const handleDragSelectMouseMove = useMemo(() => throttle((ev) => {
        if (refSelectWrapper.current && maskRef.current) {
            const writeMailElement = maskRef.current ? maskRef.current.closest('#writeMailInfo') : null;
            const scrollLeft = writeMailElement ? writeMailElement.scrollLeft : 0;
            const scrollTop = writeMailElement ? writeMailElement.scrollTop : 0;
            const diffScrollLeft = scrollLeft - writeMailElementInitScrollInfo.current.left;
            const diffScrollTop = scrollTop - writeMailElementInitScrollInfo.current.top;
            const { x, y } = refSelectWrapper.current.getBoundingClientRect();
            const maskWidth = `${Math.abs(ev.clientX - maskRef.current.startX + Math.abs(diffScrollLeft))}px`;
            const maskHeight = `${Math.abs(ev.clientY - maskRef.current.startY + Math.abs(diffScrollTop))}px`;
            const maskLeft = `${Math.min(maskRef.current.startX, ev.clientX) - x}px`;
            const maskTop = `${Math.min(maskRef.current.startY, ev.clientY) - y}px`;
            maskRef.current.style.width = maskWidth;
            maskRef.current.style.height = maskHeight;
            maskRef.current.style.left = maskLeft;
            maskRef.current.style.top = maskTop;
            maskRef.current.startX -= diffScrollLeft;
            maskRef.current.startY -= diffScrollTop;
            setDragSelectEmails(ev.clientX, ev.clientY);
        }
    }, 100), []);
    useEffect(() => {
        return () => {
            handleDragSelectMouseMove.cancel();
        };
    }, []);
    const resetMaskValue = () => {
        if (maskRef.current) {
            elementToggle(maskRef.current, false);
            maskRef.current.startX = 0;
            maskRef.current.startY = 0;
            maskRef.current.endX = 0;
            maskRef.current.endY = 0;
            maskRef.current.style.width = 0;
            maskRef.current.style.height = 0;
            maskRef.current.style.left = 0;
            maskRef.current.style.top = 0;
        }
    };
    const setDragSelectEmails = useCallback((endX, endY) => {
        if (refSelectWrapper.current && maskRef.current) {
            const startPoint = {
                x: maskRef.current.startX,
                y: maskRef.current.startY,
            };
            const endPoint = {
                x: endX,
                y: endY,
            };
            const selected = getSelectedEmailsByPoints(refSelectWrapper.current, startPoint, endPoint);
            doSelectTags({ emails: selected, type });
        }
    }, [type, doSelectTags]);
    const handleDragSelectMouseUp = (ev) => {
        if (refSelectWrapper.current && maskRef.current) {
            setDragSelectEmails(ev.clientX, ev.clientY);
            resetMaskValue();
            refSelectWrapper.current.removeEventListener('mousemove', handleDragSelectMouseMove);
            refSelectWrapper.current.removeEventListener('mouseup', handleDragSelectMouseUp);
        }
    };
    const hanldeDragSelectMouseDown = (ev) => {
        if (ev.currentTarget !== ev.target)
            return;
        if (refSelectWrapper.current && maskRef.current) {
            maskRef.current.startX = ev.clientX;
            maskRef.current.startY = ev.clientY;
            elementToggle(maskRef.current, true);
            const writeMailElement = maskRef.current ? maskRef.current.closest('#writeMailInfo') : null;
            writeMailElementInitScrollInfo.current = {
                top: writeMailElement ? writeMailElement.scrollTop : 0,
                left: writeMailElement ? writeMailElement.scrollLeft : 0,
            };
            refSelectWrapper.current.addEventListener('mousemove', handleDragSelectMouseMove);
            refSelectWrapper.current.addEventListener('mouseup', handleDragSelectMouseUp);
        }
    };
    const handleDragSelectMouseDownWrap = useCreateCallbackForEvent(hanldeDragSelectMouseDown);
    const box = useMemo(() => {
        if (refSelectWrapper.current) {
            return refSelectWrapper.current.querySelector('.ant-select-selector');
        }
        return null;
    }, [refSelectWrapper.current]);
    useEffect(() => {
        box === null || box === void 0 ? void 0 : box.addEventListener('mousedown', handleDragSelectMouseDownWrap);
        return () => {
            box === null || box === void 0 ? void 0 : box.removeEventListener('mousedown', handleDragSelectMouseDownWrap);
        };
    }, [box]);
    useEffect(() => {
        const dropArea = document.querySelector(`.${styles.selectorWrapper}.${type}`);
        dropArea === null || dropArea === void 0 ? void 0 : dropArea.addEventListener('drop', dropListener);
        dropArea === null || dropArea === void 0 ? void 0 : dropArea.addEventListener('dragover', dragoverListener);
        return () => {
            dropArea === null || dropArea === void 0 ? void 0 : dropArea.removeEventListener('drop', dropListener);
            dropArea === null || dropArea === void 0 ? void 0 : dropArea.removeEventListener('dragover', dragoverListener);
        };
    }, [dropListener, selectedEmails.length, type]);
    useEffect(() => {
        const list = items || [];
        if (autoFocus && list.length === 0) {
            setTimeout(() => { var _a; return (_a = refSelect === null || refSelect === void 0 ? void 0 : refSelect.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 100);
        }
    }, [autoFocus, items]);
    useEffect(() => {
        if (!/^\s+$/.test(keyword) && keyword !== '') {
            debouncedSearch(keyword);
        }
        else {
            setOptions([]);
        }
        return () => {
            debouncedSearch.cancel();
        };
    }, [keyword]);
    const addItem = async (list) => {
        if (list === null || list === void 0 ? void 0 : list.length) {
            let { list: unqiueList, newInputOrder } = inputOrderUnique([...selectedItems.values()], list);
            if (unqiueList.length > RECEIVER_LIMIT) {
                showDialog({
                    title: `联系人总数最多为${RECEIVER_LIMIT}人，已为您截断${unqiueList.length - RECEIVER_LIMIT}位多余联系人`,
                });
                unqiueList = unqiueList.slice(0, RECEIVER_LIMIT);
            }
            const eventName = mapTrack.get(type);
            trackApi.track(eventName, { source: getIn18Text('CONGTONGXUNLUTIAN') });
            await modifyReceiver({
                receiver: unqiueList,
                receiverType: type,
            });
            setInputOrder(newInputOrder);
            setTimeout(() => { var _a; return (_a = refSelect === null || refSelect === void 0 ? void 0 : refSelect.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 50);
        }
    };
    useEffect(() => {
        if (selector.focused === '正文') {
            setBlurStyle({ height: 40, overflow: 'hidden' });
        }
        if (selector.focused === type) {
            setBlurStyle({ height: 'auto', overflow: 'auto' });
        }
        if (!selector || !selector.add || refAdding.current[selector.focused || 'to']) {
            return;
        }
        const { pendingItem, add, focused } = selector;
        const focusedSel = focused || 'to';
        refAdding.current[focusedSel] = true;
        if (add && pendingItem && focusedSel === type) {
            const list = Array.isArray(pendingItem) ? pendingItem : [pendingItem];
            const contactItemList = list.map(item => {
                const contactItem = transContactModel2ContactItem(item);
                return Object.assign(Object.assign({}, contactItem), { mailMemberType: type });
            });
            addItem(contactItemList).then(() => {
                doAddItemToSelector({
                    add: false,
                    pendingItem: [],
                });
                refAdding.current[focusedSel] = false;
            });
        }
    }, [selector]);
    const changeKeyword = useCallback((value) => {
        keywordRef.current = value;
        setKeyword(value);
    }, []);
    const initLabelItems = useCallback((list) => {
        const res = [];
        list.forEach(item => {
            var _a, _b, _c, _d, _e;
            if (!!((_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.trim())) {
                if ((_c = (_b = item.label) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.item) {
                    res.push((_e = (_d = item.label) === null || _d === void 0 ? void 0 : _d.props) === null || _e === void 0 ? void 0 : _e.item);
                }
                else {
                    const contactItem = buildContactItem({ item: item.value.trim(), email: item.value.trim(), type });
                    res.push(contactItem);
                }
            }
        });
        return res;
    }, [type]);
    const inputOrderUnique = useCallback((list, newList) => {
        const itemMap = {};
        list.forEach(item => {
            const key = getContactItemKey(item);
            itemMap[key] = item;
        });
        const needInsertList = [];
        newList.forEach(item => {
            const key = getContactItemKey(item);
            const pre = itemMap[key];
            if (pre) {
                if (newList.length === 1) {
                    message.error('联系人已添加');
                }
                itemMap[key] = getValidEmail(pre, item);
            }
            else {
                needInsertList.push(item);
            }
        });
        const index = list.length - inputOrder;
        list.splice(index, 0, ...needInsertList);
        return {
            list,
            newInputOrder: inputOrder,
        };
    }, [inputOrder]);
    const handleDelete = (items) => {
        const itemList = initLabelItems(items);
        modifyReceiver({ receiver: itemList, receiverType: type });
    };
    const handleChange = useCallback(async (items) => {
        var _a, _b, _c;
        const lastItem = items.pop();
        if (lastItem === undefined) {
            modifyReceiver({ receiver: [], receiverType: type });
            return;
        }
        let changeItem = (_b = (_a = lastItem === null || lastItem === void 0 ? void 0 : lastItem.label) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.item;
        const itemValue = (_c = lastItem === null || lastItem === void 0 ? void 0 : lastItem.value) === null || _c === void 0 ? void 0 : _c.trim();
        if (!changeItem && itemValue) {
            changeItem = buildContactItem({ item: itemValue, email: itemValue, type });
        }
        let curSelectedContactItem = [];
        if (changeItem === null || changeItem === void 0 ? void 0 : changeItem.orgType) {
            const orgItem = changeItem;
            const useEdm = orgItem.orgType === 'customer' || orgItem.orgType === 'clue';
            const contactList = useEdm
                ? await getCustomerContactByCustomerIds([orgItem.id])
                : await contactApi.doGetContactByOrgId({ orgId: [orgItem.id], showDisable: true });
            curSelectedContactItem = contactList.map(item => transContactModel2ContactItem(item));
        }
        else {
            const currentItem = changeItem;
            curSelectedContactItem = [currentItem];
        }
        let { list: uniqueList, newInputOrder } = inputOrderUnique([...selectedItems.values()], curSelectedContactItem);
        if (uniqueList.length > RECEIVER_LIMIT) {
            showDialog({
                title: `联系人总数最多为${RECEIVER_LIMIT}人，已为您截断${uniqueList.length - RECEIVER_LIMIT}位多余联系人`,
            });
            uniqueList = uniqueList.slice(0, RECEIVER_LIMIT);
        }
        if (selectedItems.size < items.length) {
            const eventName = mapTrack.get(type);
            trackApi.track(eventName, { source: getIn18Text('SHOUDONGSHURU') });
        }
        await modifyReceiver({ receiver: uniqueList, receiverType: type });
        setInputOrder(newInputOrder);
        setOptions([]);
    }, [inputOrder, selectedItems, modifyReceiver, setInputOrder]);
    const onFocus = useCallback(() => {
        setFocus(true);
        if (selector.focused !== type) {
            doFocusSelector(type);
        }
        setBlurStyle({ height: 'auto', overflow: 'auto' });
    }, []);
    const onBlur = useCallback(() => {
        setFocus(false);
    }, []);
    useImperativeHandle(ref, () => ({
        focus: () => {
            var _a;
            (_a = refSelect === null || refSelect === void 0 ? void 0 : refSelect.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
        blur: () => {
            var _a;
            (_a = refSelect === null || refSelect === void 0 ? void 0 : refSelect.current) === null || _a === void 0 ? void 0 : _a.blur();
        },
        get wrapperHeight() {
            return 44;
        },
    }));
    const selectProps = focus && multiLine ? {} : { maxTagCount: 'responsive' };
    const handlePasteImportMails = async (clipboardData) => {
        const extractEmails = extractEmailsFromText(clipboardData);
        if ((extractEmails === null || extractEmails === void 0 ? void 0 : extractEmails.length) === 0) {
            changeKeyword(clipboardData);
            return;
        }
        const result = await mailApi.getContractItemByEmail(extractEmails.map(item => item.mail), 'to');
        const contactItemList = result.map(transMailContactModel2ContactItem);
        const { list: uniqueList, newInputOrder } = inputOrderUnique([...selectedItems.values()], contactItemList);
        await modifyReceiver({
            receiver: uniqueList,
            receiverType: type,
        });
        setInputOrder(newInputOrder);
    };
    const handleInterceptPasteEvent = async (e) => {
        const { which, metaKey, ctrlKey } = e;
        onKeyDown && onKeyDown(e);
        const holdingCtrl = metaKey || ctrlKey;
        if (holdingCtrl && which === KeyCode.A) {
            setTimeout(() => { var _a; return (_a = refSelect === null || refSelect === void 0 ? void 0 : refSelect.current) === null || _a === void 0 ? void 0 : _a.blur(); }, 100);
        }
    };
    const contextMenu = (React.createElement(Menu, null,
        React.createElement(Menu.Item, { onClick: async () => {
                if (!(await isSupportPaste())) {
                    SiriusModal.error({
                        content: '您的浏览器版本过低，请使用键盘快捷键（Ctrl+V）。或升级到新版chrome浏览器使用',
                        okText: getIn18Text('ZHIDAOLE'),
                        hideCancel: true,
                    });
                    return;
                }
                const clipboardData = await paste();
                clipboardData && handlePasteImportMails(clipboardData);
            } }, getIn18Text('ZHANTIE'))));
    const itemKeys = useMemo(() => {
        const key = items.map(item => item.contactItem.id + '#' + item.contactItem.contactItemVal).join(',');
        return key;
    }, [items]);
    const selectValue = useMemo(() => {
        const list = [];
        items.forEach(item => {
            const contactItem = transMailContactModel2ContactItem(item);
            list.push(buildOptionLabel(contactItem));
        });
        return list;
    }, [itemKeys]);
    const dropForSort = useCallback((e) => {
        var _a, _b;
        const fromType = (_a = e === null || e === void 0 ? void 0 : e.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData('type');
        if (fromType !== type)
            return;
        const [lastTop, lastRight] = lastItemPos;
        const dropX = e.clientX;
        const dropY = e.clientY;
        if (lastTop && lastRight && dropX > lastRight && dropY > lastTop) {
            const draggingData = (_b = e === null || e === void 0 ? void 0 : e.dataTransfer) === null || _b === void 0 ? void 0 : _b.getData('label');
            const _draggingData = JSON.parse(draggingData);
            const first_draggingData = _draggingData[0];
            const deleted = [];
            if (selectedEmails === null || selectedEmails === void 0 ? void 0 : selectedEmails.includes(first_draggingData === null || first_draggingData === void 0 ? void 0 : first_draggingData.email)) {
                selectedItems.forEach(item => {
                    if (!(selectedEmails === null || selectedEmails === void 0 ? void 0 : selectedEmails.includes(item.email))) {
                        deleted.push(item);
                    }
                });
            }
            else {
                selectedItems.forEach(item => {
                    if (item.email !== first_draggingData.email) {
                        deleted.push(item);
                    }
                });
            }
            deleted.push(..._draggingData);
            modifyReceiver({ receiverType: fromType, receiver: deleted });
        }
    }, [type, lastItemPos, selectedEmails, selectedItems, modifyReceiver]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectorProvider, { items: items, type: type, selectedEmails: selectedEmails },
            React.createElement("div", { ref: refSelectWrapper, style: Object.assign(Object.assign({ width: '100%' }, blurStyle), { position: 'relative' }), onDrop: dropForSort },
                React.createElement(Dropdown, { overlay: contextMenu, trigger: ['contextMenu'] },
                    React.createElement(Select, Object.assign({ dropdownClassName: styles.selectorDropdown, className: classnames(styles.selectorWrapper, {
                            [type]: true,
                        }), listHeight: LIST_HEIGHT, virtual: true, mode: "tags", size: "large", style: { width: '100%', paddingBottom: 4 }, notFoundContent: null, bordered: false, searchValue: keyword, value: selectValue, inputOrderExternal: inputOrder, onChange: handleChange, onDelete: handleDelete, onSelect: selectItem, onSearch: changeKeyword, onPaste: (e) => {
                            const { clipboardData } = e;
                            const value = clipboardData.getData('text');
                            handlePasteImportMails(value);
                            e.preventDefault();
                        }, onInputOrderChange: setInputOrder, tokenSeparators: tokenSeparators, tagRender: tagRender, onKeyDown: handleInterceptPasteEvent, maxTagPlaceholder: () => `共${selectedItems.size}人`, open: Boolean(keyword && options.length), tabIndex: tabIndex, optionFilterProp: "search" }, selectProps, { onFocus: onFocus, onBlur: onBlur, options: options, filterOption: true, labelInValue: true, ref: refSelect, selectDisabled: selectDisabled }))),
                React.createElement("div", { className: "drag-mask", ref: maskRef, style: {
                        zIndex: 999,
                        background: 'transparent',
                        position: 'absolute',
                        opacity: 0,
                        display: 'none',
                    } }))),
        React.createElement(LxPopover, { top: contactPos.top, left: contactPos.left, right: contactPos.right, bottom: contactPos.bottom, visible: contactCardVisible, offset: [5, 40] }, contactCardInfo && (React.createElement(ContactDetail, { showClose: true, email: contactCardInfo.email, contactId: contactCardInfo.email ? undefined : contactCardInfo.id, contact: buildContactModel(contactCardInfo), dividerLine: false, _account: curAccount === null || curAccount === void 0 ? void 0 : curAccount.mailEmail, onNotifyParent: () => {
                setContactCardVisible(false);
            }, branch: true, toolipShow: true })))));
};
export default React.forwardRef(Selector);
